module.exports = __webpack_public_path__ + "img/logo.7fc823b6.png";